<template>
  <nav class="panel">
    <p class="panel-heading">
      Order overview
    </p>
    <div class="panel-block order-overview">
      <table class="table is-fullwidth">
        <tbody>
        <tr>
          <td>Order price</td>
          <td class="has-text-right">
            Free
          </td>
        </tr>
        <tr>
          <td>Fee</td>
          <td class="has-text-right">
            Free
          </td>
        </tr>
        <tr>
          <td>Shipping price</td>
          <td class="has-text-right">
            <span>
              Free
            </span>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </nav>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'OrderOverview',

  props: {
    priceCheck: Object
  },

  data () {
    return {
      minPrice: 0,
      maxPrice: 0
    }
  },
  watch: {
    priceCheck: function () {
      if (this.priceCheck) {
        let minPrice = 0
        let maxPrice = 0

        for (let shipment of this.priceCheck.shipments) {
          let prices = []

          for (let quote of shipment.quotes) {
            prices.push(parseFloat(quote.price))
          }

          minPrice += _.min(prices)
          maxPrice += _.max(prices)
        }

        this.minPrice = minPrice
        this.maxPrice = maxPrice
      }
    }
  }
}
</script>
